export default "__VITE_ASSET__BEXCAvjl__"